module.exports = __webpack_public_path__ + "static/media/why-cswap-x-midnight.97134db0.png";